/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */

import React from 'react';

import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';

import OtpInput from '@ntuctech/devex-tangram/OtpInput';

import { useAuth0 } from '../../Auth0Provider';
import FormWrapper from '../../theme/FormWrapper';
import FormElement from '../../theme/FormElement';
import FormActions from '../../theme/FormActions';

const gaScreenName = 'OTP';
const OTP_LENGTH = 6;

const VerifyPhoneNumberForm = (props) => {
  const { trackPwl } = useAuth0();
  const { isSubmitting, submitForm, setFieldValue, formError, setFormError, sendOtp, values } =
    props;

  const gaRef = React.useRef({});

  const { verificationCode } = values;

  const isSubmitButtonDisabled = verificationCode.length < OTP_LENGTH;

  const handleOtpChange = (e) => {
    if (!gaRef.current.OTPTypeTracked) {
      trackPwl({
        screen_name: gaScreenName,
        event_action: 'Fill In',
        event_label: 'SignIn_OTP_Initiated',
      });
    }
    gaRef.current.OTPTypeTracked = true;

    setFormError('');
    setFieldValue('verificationCode', e.target.value);
  };

  const handleKeyPress = React.useCallback(
    (event) => {
      if (event.key === 'Enter' && !isSubmitButtonDisabled) {
        event.target.blur();
        submitForm();
      }
    },
    [submitForm, isSubmitButtonDisabled],
  );

  return (
    <FormWrapper hideLabel>
      <FormElement>
        <OtpInput
          id="OtpInput"
          label=""
          data-testid="OtpInput"
          length={OTP_LENGTH}
          isNum
          resendTimer={25}
          isInitialCounter
          onResend={sendOtp}
          error={Boolean(formError)}
          onChange={handleOtpChange}
          onKeyPress={handleKeyPress}
          value={verificationCode}
          fullWidth
          singleInput
        />
      </FormElement>
      <FormActions>
        <ButtonContained
          type="button"
          fullWidth
          compact
          disabled={isSubmitButtonDisabled}
          loading={isSubmitting}
          onClick={submitForm}
          data-testid="verifyPhoneButtonSubmit"
        >
          Verify
        </ButtonContained>
      </FormActions>
    </FormWrapper>
  );
};

export default VerifyPhoneNumberForm;
